import { FilesViewerFile } from '@arsultima/file-viewer';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SlideshowService {
  constructor() {}

  private images: FilesViewerFile[] = [];

  setImages(images: FilesViewerFile[]) {
    this.images = this.replaceByHiRes(images);
  }

  replaceByHiRes(images: FilesViewerFile[]): FilesViewerFile[] {
    const newImages: FilesViewerFile[] = [];
    images.forEach(image => {
      if (image.src.includes('BaseM/M_')) {
        newImages.push({
          ...image,
          src: image.src.replace('BaseM/M_', 'BaseH/H_'),
        });
      } else {
        newImages.push(image);
      }
    });
    return newImages;
  }

  getImages(): FilesViewerFile[] {
    return this.images;
  }
}
